/**
 * Route prefixes where the TOTP activation promo must never appear, regardless of store state.
 * - Viewer (incl. anti-capture) and online Office (Collabora/WOPI) are full-screen document flows.
 * - Protected file gate pages precede the viewer token flow.
 */
const SUPPRESSED_PREFIXES = [
  '/viewer',
  '/file/protected',
  '/document/',
  '/spreadsheet/',
  '/presentation/',
  // Extension token handoff — keep the authorize page unobstructed
  '/extension/authorize',
  // legacy prefixes kept so promo does not flash during Navigate replace bounce
  '/word/',
  '/excel/',
  '/powerpoint/',
  '/wopitest/',
] as const;

export function isActivateTotpPromoSuppressedPath(pathname: string): boolean {
  return SUPPRESSED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
